export default __webpack_public_path__ + "static/media/background_register.351e2545.jpg";